import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

import { useSettingsInitializer } from '@/hooks/useSettingsInitializer';
import { LoggerContext, defaultLogger } from '@/lib/logger';

import './index.css';
import './i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
});

function AppBootstrap() {
  useSettingsInitializer();
  return <App />;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LoggerContext.Provider value={defaultLogger}>
      <QueryClientProvider client={queryClient}>
        <AppBootstrap />
      </QueryClientProvider>
    </LoggerContext.Provider>
  </React.StrictMode>,
);
